export default function accessManagmentNavService(gettext) {
  'ngInject';

  this._module = {
    id: 'access-management',
    name: gettext('Access Management'),
    sref: 'access-management',
    icon: 'fas fa-users-cog',
    priority: 9,
    items: [
      {
        name: gettext('Group List'),
        sref: 'access-management.group-list',
        group: 'groups'
      },
      {
        name: gettext('Asset List'),
        sref: 'access-management.assets-list',
        group: 'assets'
      },
      {
        name: gettext('Assignments'),
        sref: 'access-management.assignments',
        group: 'assets'
      },
      {
        name: gettext('Operator List'),
        sref: 'access-management.operators-list',
        group: 'operators'
      },
      {
        name: gettext('Bulk Upload Operators'),
        sref: 'access-management.operators-bulk-upload',
        group: 'operators'
      }
    ],
    groups: [
      {
        id: 'groups',
        name: gettext('Groups')
      },
      {
        id: 'assets',
        name: gettext('Assets')
      },
      {
        id: 'operators',
        name: gettext('Operators')
      }
    ]
  };

  return {
    getModule: () => this._module
  };
}
